import * as types from "../../../databse/types";

export const actionModalChangeAddressChangeShow = (show, destination, fromEditOrder = false) => ({
    type: types.MODAL_CHANGE_ADDRESS_CHANGE_SHOW,show,destination, fromEditOrder
});

export const actionModalChangeAddressChangeLoader = (loader) => ({
    type: types.MODAL_CHANGE_ADDRESS_CHANGE_LOADER,loader
});

